import React from 'react';
import clsx from 'clsx';
import { has } from '../../../services';
import { Button, ButtonColor } from '../../button';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * Info Block Action
 * @param children {React.ReactNode} Button text content
 * @param onClick {Function} OnClick event
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS Classes
 */
const InfoBlockAction = ({ className, children, onClick, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('info-block-action', has('text-centered'), className));
    return (React.createElement("div", { "data-testid": testId, className: classes, ...others }, children && typeof children.valueOf() === 'string' ? (React.createElement(Button, { onClick: onClick, variant: ButtonColor.PRIMARY }, children)) : (children)));
};
export default InfoBlockAction;
//# sourceMappingURL=InfoBlockAction.js.map